import { BooleanColumn } from "./BooleanColumn";
import { DateColumn } from "./DateColumn";
import { NumberColumn } from "./NumberColumn";
import { SetColumn } from "./SetColumn";
import { TextColumn } from "./TextColumn";
import { UUIDColumn } from "./UUIDColumn";
import { DateTimeColumn } from "./DateTimeColumn";
import { OneToManyColumn } from "~utils/Grids/ColumnTypes/OneToManyColumn";
import { DefaultColumn } from "~utils/Grids/ColumnTypes/DefaultColumn";

export const columnTypes = {
	BooleanColumn,
	DateColumn,
	DateTimeColumn,
	DefaultColumn,
	NumberColumn,
	TextColumn,
	SetColumn,
	OneToManyColumn,
	UUIDColumn,
};
